import React from 'react'
import { formatBRL } from 'utils/progressiveDiscount'
import * as Style from './styles'

interface Payer {
  entity: string
  amount: number
}

interface ProgressiveDiscountEntry {
  rule_id?: number
  rule_name?: string
  discount: number
  payers?: Payer[]
}

interface Props {
  progressiveDiscount?: ProgressiveDiscountEntry[]
  side?: 'label' | 'value'
}

const totalDiscount = (entries: ProgressiveDiscountEntry[]) =>
  entries.reduce((sum, e) => sum + e.discount, 0)

export const OrderProgressiveSummary = ({ progressiveDiscount, side }: Props) => {
  if (!progressiveDiscount || progressiveDiscount.length === 0) return null

  const total = totalDiscount(progressiveDiscount)
  if (total === 0) return null

  if (side === 'label') {
    return <Style.Label>Desconto progressivo</Style.Label>
  }

  if (side === 'value') {
    return <Style.Value>- {formatBRL(total)}</Style.Value>
  }

  // Modo completo: exibe apenas o rateio por pagador (total já aparece no grid via side='label'/'value')
  const allPayers = progressiveDiscount.flatMap(e => e.payers ?? [])

  const payerTotals = allPayers.reduce<Record<string, number>>((acc, p) => {
    acc[p.entity] = (acc[p.entity] ?? 0) + p.amount
    return acc
  }, {})

  if (Object.keys(payerTotals).length === 0) return null

  return (
    <Style.Container>
      <Style.PayersContainer>
        <Style.PayersTitle>Rateio do desconto progressivo</Style.PayersTitle>
        {Object.entries(payerTotals).map(([entity, amount]) => (
          <Style.PayerRow key={entity}>
            <span>{entity}</span>
            <span>- {formatBRL(amount)}</span>
          </Style.PayerRow>
        ))}
      </Style.PayersContainer>
    </Style.Container>
  )
}
